import styled from "styled-components";

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${({ theme }) => theme.spacing.lg};

  & > * {
    margin-bottom: 0;
  }

  & > * + * {
    margin-top: ${({ theme }) => theme.spacing.md};
  }
`;

export const CarFormIngressCoverages = styled.p`
  font-weight: 600;
  margin-bottom: var(--spacer-xs);
`;

export const CarFormIngressCheckPrice = styled.p`
  font-weight: 600;
  margin-bottom: var(--spacer-m);
  margin-top: var(--spacer-l);
`;

export const CoverageRadioGroup = styled.fieldset`
  border: 0;
  padding: 0;
`;
